module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-plus-wrapper"
  }, [_c('el-card', [_c('div', {
    staticClass: "dashboard-plus-button"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-188e7be8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardPlusButton.vue
// module id = 1127
// module chunks = 23